import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

// LIST ALL Target Audience
export const audienceList = (params = '') => Http.get(`/target-audiences${serialize(params)}`)
export const audienceCreate = (params = '') => Http.post('/target-audiences', params)
export const audienceByID = (params = '') => Http.get(`/target-audiences/${params}`)
export const audienceUpdate = (params = '') => Http.put(`/target-audiences/${params.id}`, params)
export const audienceDestroy = (params = '') => Http.delete(`/target-audiences/${params.id}`)
